import { handlePostRequest } from '.';
import { URI } from '../../constants/URI';
import { setUser } from '../slices/authSlice';
import { store } from '../store';
import { getUsers } from './users';

export const registerUser = async (body, { isFetch = false }) => {
  const res = await handlePostRequest(URI.register, body);
  if (res?.ack && isFetch) getUsers();
  return res;
};

export const loginUser = async (body) => {
  const res = await handlePostRequest(URI.login, body);
  if (res?.ack) {
    store.dispatch(setUser(res.user));
  }
  return res;
};

export const resetPassword = async (body) => {
  const res = await handlePostRequest(URI.reset_password, body);
  return res;
};

export const forgotPassword = async (body) => {
  const res = await handlePostRequest(URI.forgot_password, body, {
    toast: false,
  });
  return res;
};
